import { Challenge } from "./Challenge";
import { t as msg } from "../lib/i18n";
import type { useVerifiedSubmission } from "../lib/useVerifiedSubmission";
export function SubmissionCheck({ action, submission }: { action: string; submission: ReturnType<typeof useVerifiedSubmission> }) {
  const intent = submission.intent;
  if (!intent) return null;
  return <div className="submission-check" role="region" aria-label={msg("Verifying…")}>
    <p role="status">{msg("Verifying…")}</p>
    <Challenge key={intent.id} action={action} onToken={token => void submission.verified(intent.id, token)} />
    <button type="button" className="text-button" onClick={submission.cancel}>{msg("Cancel")}</button>
  </div>;
}
